/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";
import { indigo } from "@mui/material/colors";
import { useAuth } from "../../context/authContext";

function Navbar() {
  const { userData } = useAuth();
  return (
    <>
      <header
        id="header"
        className="header fixed-top d-flex align-items-center"
      >
        <div className="d-flex align-items-center justify-content-between">
          <div style={{ marginRight: "16px", display: 'flex' }}>
            <div style={{ marginRight: "16px" }}>
              <i
                className="bi bi-list toggle-sidebar-btn"
                onClick={() =>
                  document
                    .querySelector("body")
                    .classList.toggle("toggle-sidebar")
                }
              ></i>
            </div>
            <div style={{ height: '40px' }}>
              <NavLink className="logo d-flex align-items-center" to="/">
                <span className="nav-heading">
                  <img
                    src="/images/alpha-targeting-logo.png"
                    alt="logo"
                    width={120}
                    height={'80px'}
                  />
                </span>
              </NavLink>
            </div>
          </div>
        </div>

        <nav className="header-nav ms-auto">
          <ul className="d-flex align-items-center">
            <li className="nav-item d-block d-md-none">
              <a
                className="nav-link nav-icon search-bar-toggle"
                onClick={() =>
                  document
                    .querySelector(".search-bar")
                    .classList.toggle("search-bar-show")
                }
              >
                <i className="bi bi-search"></i>
              </a>
            </li>

            <li className="nav-item dropdown pe-3 nav-link nav-profile d-flex align-items-center pe-0">
              <Avatar
                sx={{
                  bgcolor: indigo[100],
                  width: "32px",
                  height: "32px",
                }}
              >
                {userData && userData.name && userData.name[0]}
              </Avatar>
              <span className="nav-profile-name" style={{ marginLeft: "10px" }}>
                {userData && userData?.name}
              </span>
            </li>
            {/* <!-- End Profile Nav --> */}
          </ul>
        </nav>
        {/* <!-- End Icons Navigation --> */}
      </header>
    </>
  );
}

export default Navbar;




